import tagStyle from "../templates/Tag.style";
import tagHzeroStyle from "../templates-hzero/Tag.style";
var tagData = {
  name: 'tag',
  data: [{
    padding: '0 4px',
    borderRadius: '2px'
  }],
  onlyTemplate: {
    base: tagStyle,
    hzero: tagHzeroStyle
  }
};
export default tagData;